import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {downloadFile} from '../../api';

class DBDownloadItem extends Component {

    downloadAttachment = (e, fileId) => {
        e.preventDefault();

        downloadFile(fileId);
    }

    render(){
            const { downloadItems } = this.props;

            return (   
                <div style={{marginLeft: "32px", marginBottom: "12px"}}>                            
                <ReactTable
                    data={downloadItems}
                    pageSize={(downloadItems.length > 10) ? 10 : downloadItems.length}
                    showPagination={(downloadItems.length > 10)}
                    columns={[{
                        Header: 'Name',
                        accessor: 'title' // String-based value accessors!
                        },{
                        Header: 'Download',
                        accessor: 'fileId', // String-based value accessors!
                        Cell: props => <button onClick={(e) => this.downloadAttachment(e, props.value)}>View</button>
                        }
                    ]}                                        
                />
                </div>                 
        )
    }
}

export default DBDownloadItem
